











































import { Component, Vue, Prop } from "vue-property-decorator"; 
import Radio from '@/pages/showDetail/Radio.vue';

@Component({
  components: {
    'radio': Radio,
  },
})
export default class CancelModal extends Vue {
  @Prop({ default: false, type: Boolean }) show!: boolean;
  @Prop() configOption!: any;
  @Prop() canPay!: boolean;
  @Prop() chooseItem!: any;

  anonymity: boolean = true;
  

  radioList: Array<object> = [
    {
      value: '定金',
      label: '定金',
    },
    {
      value: '全额',
      label: '全额',
    },
  ];
  // 点击确定
  handleOk(): void {
    this.$emit("ok", this.anonymity);
  }

  handleCancle(): void {
    this.$emit("hide");
    this.anonymity = true;
  }
  handleAnonymity(val:boolean): void{
    this.anonymity = val;
  }
}
